import React, { useState, useCallback, useEffect } from 'react';
import ConfiguracionLogic from '../../functions/logic/Configuracion';
import Spiner from '../../components/General/Spiner';
import DynamicCard from '../../components/DataTables/DynamicCard';
import Logs from '../../components/General/LogDetail';
import TableroDetailsAll from './TableroDetailsAll';

const AreaCard = () => {
    const [spiner, setSpiner] = useState(false);
    const [listCardTableros, setListCardTableros] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [selectOption, setSelectOption] = useState('dashboard');
    const [selectedButton, setSelectedButton] = useState(null);
    const [dataFavRec, setDataFavRec] = useState([]);

    const handleAccessClick = (idAreaBI) => {
        localStorage.setItem('idAreaBI', idAreaBI);
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click tarjeta area id: " + idAreaBI, 'vizualizar area id: ' + idAreaBI, '/lista-areas', localStorage.getItem('codigoUsuario'));
        window.location.href = global.TABLERO_DETAIL;
    };

    const getAreasTableros = useCallback(async (idArea, page, perPage, seacrh = '') => {
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
        setSpiner(true);
        const respAreas = await ConfiguracionLogic.areasNewLogicBi(idArea, page, perPage, seacrh);
        if (respAreas.success) {
            setListCardTableros(respAreas.data);
            setTotalRows(respAreas.totalRows);
        }
        setSpiner(false);
    }, []);

    useEffect(() => {
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
        getAreasTableros(0, 1, 9, '');
    }, [getAreasTableros]);

    const handlePageChange = (page, perPage) => {
        getAreasTableros(0, page, 9, '');
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
    };

    const handleSearch = (item) => {
        getAreasTableros(0, 1, 9, item);
        if (localStorage.getItem("returnBiDEtail") && localStorage.getItem("returnBiDEtail") === '2') {
            setSelectOption('areas')
        } else {
            setSelectOption('dashboard')
        }
    };

    const handleSelectChange = (e) => {
        setSelectOption(e.target.value);
        if (e.target.value === "areas") {
            localStorage.setItem('returnBiDEtail', 2)
        }
        else {
            localStorage.setItem('returnBiDEtail', 1)
        }
    };

    const handleFavoritosClick = async () => {
        setSelectedButton('favoritos');
        setSpiner(true);
        const resp = await ConfiguracionLogic.tableroRecienteFavLogic("favoritos");
        if (resp.success) {
            setDataFavRec(resp);
        }
        setSpiner(false);
    };

    const handleRecientesClick = async () => {
        setSelectedButton('recientes');
        setSpiner(true);
        const resp = await ConfiguracionLogic.tableroRecienteFavLogic("recientes");
        if (resp.success) {
            setDataFavRec(resp);
        }
        setSpiner(false);
    };

    const todosClick = async () => {
        setDataFavRec([])
        setSelectedButton(null)
    };

    const getButtonClass = (type) => {
        const isSelected = selectedButton === type;
        return `btn rounded-pill mr-2 ${isSelected
            ? 'bg-dark text-white border border-white'
            : 'bg-white text-dark border border-dark'
        }`;
    };

    return (
        <div className="content-wrapper">
            <Spiner opt={spiner} />
            <div className="d-flex justify-content-start align-items-center mb-3">
                <div className="mr-3">
                    <select
                        onChange={handleSelectChange}
                        value={selectOption}
                        className="form-control"
                    >
                        <option value="dashboard">Dashboard</option>
                        <option value="areas">Áreas</option>
                    </select>
                </div>
                {selectOption === 'dashboard' && (
                    <>
                        <button
                            onClick={handleFavoritosClick}
                            className={getButtonClass('favoritos')}
                        >
                            ⭐ Favoritos
                        </button>
                        <button
                            onClick={handleRecientesClick}
                            className={getButtonClass('recientes')}
                        >
                            🕒 Recientes
                        </button>
                        <button
                            onClick={todosClick}
                            className={'btn rounded-pill mr-2 bg-white text-dark border border-dark'}
                        >
                             Todos
                        </button>
                    </>
                )}
            </div>
            {selectOption === 'areas' ? (
                <DynamicCard
                    data={listCardTableros}
                    handleAccessClick={handleAccessClick}
                    headerText="Tableros ingresados"
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                    onSearch={handleSearch}
                />
            ) : <TableroDetailsAll dataFavRec={dataFavRec} />}
        </div>
    );
};

export default AreaCard;
